<template>
    <div>
        <q-modal v-model="showEditDialog" no-backdrop-dismiss>
            <q-toolbar color="primary" style="justify-content:space-between; width:1000px">
                    <q-toolbar-title shrink>
                    Приход материала
                    </q-toolbar-title>
            </q-toolbar>       

            <q-select 
                name='postavshiks'
                v-model="postavshik"
                :options="postavshiks"
                radio
                float-label="Выбор поставщика"
                class='q-ma-lg'
            />


            <div class="param-container full-width" style='max-width:1000px'>
                <div class='row no-wrap full-width items-baseline new-item shadow-1'>
                    <div style='max-width:32%; min-width:32%'>
                        <q-select
                            name='typeSelect'
                            v-model='materialParam.materialType'
                            :options = 'allMaterialTypes'
                            float-label="Материал"
                            @input="changeType"
                            
                        />
                    </div>
                    <div style='max-width:35%; min-width:35%'>
                        <q-select
                            name='typeSelect'
                            v-model='materialParam.nomenklatura'
                            :options = 'nomenklaturaList'
                            float-label="Номенклатура"
                            class='q-ml-md'
                            ref='input_nomenklatura'
                        />
                    </div>
                    <div style='max-width:8%; min-width:8%' class='q-ml-md'><q-input v-model=materialParam.count float-label='Кол-во, м.п.'  type="number" :decimals="2" :step="5"/></div>
                    <div style='max-width:8%; min-width:8%' class='q-ml-md'><q-input v-model=materialParam.price float-label='Цена, р/кв.м'  type="number" :decimals="2" :step="1" @keydown='priceInput'/></div>
                    <div style='max-width:10%; min-width:10%' class='q-ml-lg text-center'><q-btn color='positive' label='OK' class='full-width' @click='addInList' /></div>
                </div>
                <div class='q-mt-md' style='overflow:auto; max-height:250px'>
                    <div v-for='(item, index) in prihodList' :key="index" class='row no-wrap q-pa-sm q-body-1  items-baseline prihod-line'>
                        <div style='width:36%' class='ellipsis'>{{$store.getters.getMaterialById(item.materialType).name}}</div>
                        <div style='width:36%' class='ellipsis'>{{$store.getters.getNomenklaturaById(item.nomenklatura).name+" - "+ $store.getters.getNomenklaturaById(item.nomenklatura).width + 'м'}}</div>
                        <div style='width:10%' class='ellipsis'>{{item.count + ' м.п.'}}</div>
                        <div style='width:10%' class='ellipsis'>{{item.price}} р/м<sup>2</sup></div>
                        <div>
                            <q-btn icon='far fa-trash-alt' color="negative" flat inverted dense class='q-pr-md' @click='deleteFromList(index)'/>
                            <q-btn icon='fas fa-pencil-alt' color="positive" flat inverted dense @click='editPrihod(index)'/>
                        </div>
                    </div>
                </div>

            </div>



            <div class='button-container'>
                <q-btn
                    color="negative"
                    @click="closeEditDialog"
                    label="Отмена"
                    outline
                />
                <q-btn
                    color="positive"
                    :loading='isLoading'
                    @click="saveEditDialog"
                    style="margin-left:20px; width:150px;"
                >
                    <span v-if='materialId==-1'>Добавить</span>
                    <span v-if='materialId != -1'>Сохранить</span>
                </q-btn>

            </div>
        </q-modal>
    </div>

</template>

<script>

/* eslint-disable */
export default {
    name : 'prihodDialog',
    
    data () {
            return {
                materialId : -1, // идентификатор ИД материала. если -1 - то добавляем новый материал
                showEditDialog : false, // флаг видимости диалога
            //Параметры материала    
                isLoading : false,
                postavshik : null,
                materialParam : {
                    // postavshik : null,
                    materialType : null,
                    nomenklatura : null,
                    count : 50,
                    price : null,
                }
            }
    },

    created() {
        eventBus.$on("showPrihodDialog", ()=> {
            this.showEditDialog = true; // показываем диалоговое окно
        });
    },

    beforeDestroy() {
        eventBus.$off('showPrihodDialog');
    },

    computed : {
        
        nomenklaturaList() {
            let result = [];
            let list = this.$store.getters.getNomenklaturaByType != undefined ? this.$store.getters.getNomenklaturaByType(this.materialParam.materialType) : [];
            list.forEach(item => {
                result.push({
                    label : item.name+" - "+item.width+' м',
                    value : item.id,
                });
            });
            return result;
        },

        allMaterialTypes() {
            let result = [];
            let list = this.$store.getters.getAllMaterials != undefined ? this.$store.getters.getAllMaterials : [];
            list.forEach(item => {
                result.push({
                    label : item.name,
                    value : item.id,
                });
            });
            return result;
        },

        prihodList() {
            return this.$store.getters.prihodList;
        },

        postavshiks() {
            let result = [];
            let list = this.$store.getters.getPostavshiks != undefined ? this.$store.getters.getPostavshiks : [];
            list.forEach(item => {
                result.push({
                    label : item.name,
                    value : item.id,
                });
            });
            return result;
        },


    },

    methods : {
        priceInput(key) {
            if (key.key=='Enter') {
                this.addInList();
            }
        },
        editPrihod(index) {
            this.materialParam = this.$store.getters.getPrihodByIndex(index);
            this.$store.commit('deleteFromPrihodList', index);
        },

        deleteFromList(index) {
            this.$q.dialog({
                title: 'Внимание!',
                message: 'Удалить эту позицию прихода?',
                color: 'primary',
                ok: true, 
                cancel: true, 
                preventClose: true,
            })
            .then(()=>{
                this.$store.commit('deleteFromPrihodList', index)
            })
            .catch();
        },

        materialName(item) {
            console.log(item);
            return '';
        },
        addInList() {
            if  ((this.materialParam.materialType != null)&&
                (this.materialParam.nomenklatura != null)&&
                (this.materialParam.count != null) &&
                (this.materialParam.price != null)) {

                    this.$store.commit('addMaterialInList', JSON.parse(JSON.stringify(this.materialParam)));
                    // this.materialParam.postavshik = null;
                    this.materialParam.materialType = null;
                    this.materialParam.nomenklatura = null;
                    this.materialParam.count = 50;
                    this.materialParam.price = null;
            } else {
                this.$admns.showNotify('Не все параметры заполнены','error','проверка вводимых данных')
            }
        },

        changeType() {
            // this.$refs['input_nomenklatura'];
        },


        closeEditDialog() {
            this.showEditDialog = false;
            this.postavshik = null;
            this.$store.commit('clearMaterialsInList'); //очищаем добавленные материалы
            // this.clearFormData();
        },

        saveEditDialog() {

            if (this.postavshik == null) {
                this.$admns.showNotify('Не выбран поставщик','error','сообщение системы');
                return;
            }
            if (this.$store.getters.prihodList.length == 0) {
                this.$admns.showNotify('Нет позиций прихода. Пожалуйста добавьте.','error','сообщение системы');
                return;
            }
        
            this.isLoading = true;
            this.$store.dispatch('addNewPrihod', this.postavshik)
            .then(()=>{
                this.isLoading = false;
                this.$admns.showNotify('Приход внесен в базу','success','сообщение системы');
                this.closeEditDialog();
            })
            .catch((error)=>{
                console.log(error);
                this.isLoading = false;
                this.$admns.showNotify('Ошибка записис','error','сообщение системы');
            });
            
        },
    }

}


</script>

<style lang="scss" scoped>
    .prihod-line {
        background-color: rgb(218, 255, 225);
        cursor : pointer;
        border : 1px solid rgb(10, 9, 9);
        margin-top: 0px;
        &:hover {
            background-color: rgb(164, 255, 181);
        }
    }
    .param-container {
        padding:30px;
        min-height:400px;
    }
    .new-item{
        padding: 30px;
        background-color: rgb(224, 251, 255);
        border : 1px solid rgb(179, 179, 179);
        border-radius: 2px;
    }
    .button-container {
        padding:30px;
        text-align: right;
    }
</style>

